import { isProdDomain } from '../../utils/aem-utils';
import { getCookie } from '../../utils/cookies';

const config = require('config');

const ENABLE_LOGGER_COOKIE_NAME = config.cookieName || 'enableLogger';

export const initLoggingService = () => {
  /**
   * Determine if console logging should be enabled
   */
  const shouldEnableConsole = (() => {
    if (isProdDomain()) {
      // Production: only enabled with cookie
      return getCookie(ENABLE_LOGGER_COOKIE_NAME) === 'true';
    }
    // Non-production: enabled by default
    return true;
  })();

  /**
   * Check if message contains [Bridge] tag
   */
  const containsBridgeTag = (args) => {
    return args.some((arg) => typeof arg === 'string' && arg.includes('[Bridge]'));
  };

  /**
   * Override console methods if logging is disabled
   */
  if (!shouldEnableConsole) {
    const noop = () => {};
    console.log = noop;
    console.info = noop;
    console.warn = noop;
    console.debug = noop;
    console.trace = noop;
    // Keep console.error always enabled for critical issues
  } else {
    // Prepend prefix to all console methods except error, with different emojis
    const BASE_PREFIX = `SKY-AEM-FRONTEND v${process.env.VERSION} || `;
    const PREFIXES = {
      log: `${BASE_PREFIX}💬 `,
      info: `${BASE_PREFIX}ℹ️ `,
      warn: `${BASE_PREFIX}⚠️ `,
      debug: `${BASE_PREFIX}🐞 `,
      trace: `${BASE_PREFIX}🔍 `,
      error: `${BASE_PREFIX}❌  `,
    };
    const wrap = (orig, prefix) =>
      function (...args) {
        // Filter out [Bridge] messages
        if (containsBridgeTag(args)) {
          return;
        }

        if (args.length > 0 && typeof args[0] === 'string') {
          args[0] = prefix + args[0];
        } else {
          args.unshift(prefix);
        }
        return orig.apply(console, args);
      };
    console.log = wrap(console.log, PREFIXES.log);
    console.info = wrap(console.info, PREFIXES.info);
    console.warn = wrap(console.warn, PREFIXES.warn);
    console.debug = wrap(console.debug, PREFIXES.debug);
    console.trace = wrap(console.trace, PREFIXES.trace);
    console.error = wrap(console.error, PREFIXES.error);
    // console.error remains unchanged
  }
};
